import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { signUp } from '../services/authService';
import './Login.css';

const Signup = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const validate = () => {
    const { firstName, lastName, username, email, password, confirmPassword } = form;

    if (!firstName || !lastName || !username || !email || !password || !confirmPassword) {
      return 'All fields are required.';
    }
    if (username.length < 3) {
      return 'Username must be at least 3 characters.';
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      return 'Please enter a valid email address.';
    }
    if (password.length < 8) {
      return 'Password must be at least 8 characters.';
    }
    if (password !== confirmPassword) {
      return 'Passwords do not match.';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsSubmitting(true);
    try {
      const { error: signUpError } = await signUp({
        firstName: form.firstName,
        lastName: form.lastName,
        username: form.username,
        email: form.email,
        password: form.password,
      });

      if (signUpError) {
        setError(signUpError.message || 'Sign up failed. Please try again.');
        return;
      }

      setSuccess(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="login-page">
        <Header isLoggedIn={false} />
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <div className="character">
                <div className="character-body"></div>
                <div className="character-eye left"></div>
                <div className="character-eye right"></div>
                <div className="character-mouth"></div>
              </div>
              <h2>Account Created!</h2>
              <p>
                Your account has been created successfully. Please wait for an
                administrator to activate your account before you can log in.
              </p>
            </div>
            <div className="signup-link" style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <Link to="/login" className="login-btn" style={{ display: 'inline-block', textDecoration: 'none' }}>
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <Header isLoggedIn={false} />

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="character">
              <div className="character-body"></div>
              <div className="character-eye left"></div>
              <div className="character-eye right"></div>
              <div className="character-mouth"></div>
            </div>
            <h2>Create Account</h2>
            <p>Join Kids Word Play! Fill in your details below.</p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                className="form-control"
                placeholder="Enter your first name"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                className="form-control"
                placeholder="Enter your last name"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                placeholder="Choose a username"
                value={form.username}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter your email address"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder="Create a password (min. 8 characters)"
                value={form.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-control"
                placeholder="Repeat your password"
                value={form.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="login-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Creating Account...' : 'Create My Account'}
            </button>
          </form>

          <div className="signup-link">
            <p>Already have an account? <Link to="/login">Log In</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
